import * as React from 'react'
import Content from '../common/content'
import {Divider,Select,Checkbox,Button,Modal} from "antd"
import "./index.less"
import {axios_} from "../../tools/axios_.js"
import {connect} from "react-redux"

const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;

class Weitou extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            repositorySubList:[],
            options:[],
            value:[],   // checkBox 选中值
            repositoryId:"",
            registerFlag:0 ,//是否开放注册 0不开放
            walletFlag:0,//是否显示钱包
            orgId:'', // 选择商户的orgId
            isSave:false,//是否可以点击保存按钮
        }
    }
    componentDidMount() {
        this.getRepositorySubList();
    }
    /*获取商户Options*/
    getRepositorySubList(){
        axios_({
            url: "getRepositorySubList",
            method:"get",
            headers:{
                "access-token":this.props.token
            }
        }).then((msg)=>{
            this.setState({
               repositorySubList:msg.data
            })
           
        })
    }
    /*select选择  获取checkBox信息*/
    getRepositoryList(id){
        /*获取可否注册*/
        this.state.repositorySubList.map((v,i)=>{
            if(v.repositoryId===id){
                this.setState({
                    registerFlag:v.registerFlag,
                    walletFlag:v.walletFlag,
                    orgId:v.orgId
                })
            }
        })
        /*获取所选商户信息*/
        axios_({
            url: "getRepositoryList",
            method: "get",
            params:{
                repositoryId:id
            },
            headers: {"access-token": this.props.token}
        }).then((msg) => {
            let list = msg.data;
            let options = list.map((item,index)=>{ // checkBosGroup 配置
                item.label = item.linkInfoName;
                item.value = item.linkInfoId
                return item;
            });
            let defaultValue = [];
            defaultValue = list.reduce((arr,item)=>{
                if (item.issuance === "2"){
                    arr.push(item.linkInfoId)
                }
                return arr;
            },[])
            this.setState({
                options,
                value:defaultValue,
                repositoryId:id
            })
        })
    }
    save(){
        let linkList = this.state.value.map((item,index)=>{
            let obj = {};
            obj.linkInfoId = item;
            return obj;
        })
        let data = {
            registerFlag:this.state.registerFlag,
            walletFlag:this.state.walletFlag,
            repositoryId: this.state.repositoryId,
            linkList: linkList,
            orgId:this.state.orgId
        }
        axios_({
            url: "updateByRepositoryId",
            method:"post",
            headers:{
                "access-token": this.props.token
            },
            data
        }).then((msg)=>{
            if(msg.status == 200 && msg.data.status == 200){
                Modal.success({
                    title: '成功',
                    content: '保存成功！',
                    onOk:()=>{
                        this.getRepositorySubList(); // 成功后重新获取option（列表中包含更新后的可否开放注册信息）
                    }
                });
            }else{
                Modal.error({
                    title: '失败',
                    content: '保存失败！',
                });
            }
        })
    }
    onChange(val){
        this.setState({
            value: val
        })
    }
    render(){
        let {
            repositorySubList,
            options,
            value
        } = this.state;
        return(
            < div className="weitoubao" style = {
                    {
                        position: 'relative',
                        height: '100%',
                        display: 'flex',
                        flex: 1
                    }
                } >
                <div style={{height: '100%', display: 'flex', flex: 1}}>
                    <Content>
                        <div className="weitoubao">
                            <div className = "header"
                            style = {
                                {
                                    boxSizing: "border-box",
                                    padding: "20px 20px 0"
                                }
                            } >
                                <div>
                                    <span style={{fontSize:"16px",marginBottom:"20px"}}>商户名称：</span>
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="请先选择商户"
                                        optionFilterProp="children"
                                        onChange = {
                                            (id)=>{
                                                this.setState({isSave:true});//解冻保存按钮
                                                this.getRepositoryList(id);
                                            }
                                        }
                                        filterOption={(input, option) => {

                                            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}
                                    >
                                        {
                                            repositorySubList.map((item,index)=>{
                                                return(
                                                    < Option
                                                        value = {item.repositoryId}
                                                        key={item.repositoryId}
                                                    >
                                                        {item.orgCname}
                                                    </ Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </div>
                                < Divider />
                            </div>
                            <div className = "contain"
                            style = {
                                {
                                    fontSize: "16px",
                                    marginBottom: "20px"
                                }
                            } >
                                <div className="duoxuan">
                                    <p>1、微投保配置</p>
                                    <CheckboxGroup options = {options}
                                        value = {value}
                                        onChange = {
                                            (checkedValue) => {
                                                this.onChange(checkedValue)
                                            }
                                        }
                                    />
                                </div>
                                <div className="selfSign">
                                    <span>2、是否开放用户自主注册？</span>
                                    <Select
                                        style={{ width: 200 }}
                                        value={this.state.registerFlag}
                                        onChange={(v)=>{this.setState({registerFlag:v})}}
                                    >
                                        <Option key='0' value={0}>不开放</Option>
                                        <Option key='1' value={1}>开放</Option>
                                    </Select>
                                </div>
                                <div className="selfSign">
                                    <span>3、是否显示钱包？</span>
                                    <Select
                                        style={{ width: 200 }}
                                        value={this.state.walletFlag}
                                        onChange={(v)=>{this.setState({walletFlag:v})}}
                                    >
                                        <Option key='0' value={0}>不显示</Option>
                                        <Option key='1' value={1}>显示</Option>
                                    </Select>
                                </div>
                            </div>
                            <div className="btn"
                                 style={{"boxSizing":"border-box",padding:"20px"}}>
                                {options.length >= 0 && ( <Button disabled={!this.state.isSave} type = "primary" onClick = {()=>{
                                    this.save();
                                }}> 保存 </Button>)}
                            </div>
                        </div>
                    </Content>
                </div>
            </div>
        )
    }
}
const mapStateToProps ={
    token:(state)=>state.token
}
function mapState(state) {
    return {
        token: state.token
    }
}
export default connect(mapState)(Weitou)